import {NoteEditor} from 'notebook/notes/NoteEditorTypes';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import {MaybePromise, maybeWithLoadingScreen, runAfterResolve} from 'util/Promises';

import {getNoteLinkedGroupAdapters} from '../NoteLinkedGroupAdapters';
import {NoteLinkedGroup, NoteLinkedGroupAdapter} from '../NoteLinkedGroupConstants';

export default function asyncUpdateContainedNotePart<TGroupMetadata, TCreateGroupExtras>(
  group: NoteLinkedGroup<TGroupMetadata>,
  editor: NoteEditor,
  groupNotePartCid: string,
  updatedContainedNotePart: NotePart
): MaybePromise<void> {
  const adapter = getNoteLinkedGroupAdapters()[group.kind] as NoteLinkedGroupAdapter<
    TGroupMetadata,
    TCreateGroupExtras
  >;
  const maybeNewGroup = maybeWithLoadingScreen(
    adapter.reduceGroup(group, updatedContainedNotePart),
    'Updating...'
  );
  return runAfterResolve(maybeNewGroup, (newGroup) => {
    // Note that we look up the index of our note part since our props may be stale after async reduceGroup.
    const index = editor.getIndex(groupNotePartCid);
    if (index === -1) {
      return;
    }
    editor.itemUpdateHandler(index, {item: newGroup});
  });
}
